import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vShow as _vShow, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e8bed4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "oxd-table-header-sort" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_icon_button = _resolveComponent("oxd-icon-button")!
  const _component_oxd_icon = _resolveComponent("oxd-icon")!
  const _component_oxd_text = _resolveComponent("oxd-text")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_oxd_icon_button, {
      withContainer: false,
      name: _ctx.sortIcon,
      class: "oxd-table-header-sort-icon",
      onClick: _ctx.openDropdown
    }, null, 8, ["name", "onClick"]),
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: _normalizeClass(_ctx.classes),
      role: "dropdown"
    }, [
      _createElementVNode("ul", {
        onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeDropdown && _ctx.closeDropdown(...args)), ["stop"])),
        role: "menu"
      }, [
        _createElementVNode("li", {
          class: "oxd-table-header-sort-dropdown-item",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('order', 'ASC')))
        }, [
          _createVNode(_component_oxd_icon, { name: "sort-alpha-down" }),
          _createVNode(_component_oxd_text, { tag: "span" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('general.ascending', 'Ascending')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", {
          class: "oxd-table-header-sort-dropdown-item",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('order', 'DESC')))
        }, [
          _createVNode(_component_oxd_icon, { name: "sort-alpha-up" }),
          _createVNode(_component_oxd_text, { tag: "span" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('general.decending', 'Decending')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ], 2)), [
      [_directive_click_outside, _ctx.closeDropdown],
      [_vShow, _ctx.isActive]
    ])
  ]))
}